<template>
    <NewPlanForm
        layout="page"
        @success="onSuccess"
        @cancel="goBack"
    />
</template>

<script>
    import NewPlanForm from '@/components/Weflix/Payment/NewPlanForm.vue';

    export default {
        components: {
            NewPlanForm,
        },
        methods: {
            onSuccess() {
                this.$router.push('/admin/pagamentos');
            },
            goBack() {
                this.$router.push('/admin/pagamentos');
            },
        },
    };
</script>
